import React from "react";

export default function CompleteMessage() {
  return (
    <div>
      <div className=" align-items-center rounded-3 py-4 mt-4 ps-4 pe-5 bg-purple-gradient-darker m-3 fw-bold row col-6">
      <span>  Congrulations...</span>
      <div className="d-flex align-items-center">
        You connected Api
        <span className="text-purple p-1">6 February 1:30pm</span>
        <span > completed.</span>
      </div>
      </div>
    </div>
  );
}
